var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLitecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litecoin-ltc-logo 7",
    clipPath: "url(#clip0_721_133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0006 31.2142C31.3433 31.2142 39.7277 24.6264 39.7277 16.5C39.7277 8.37359 31.3433 1.78584 21.0006 1.78584C10.6579 1.78584 2.27344 8.37359 2.27344 16.5C2.27344 24.6264 10.6579 31.2142 21.0006 31.2142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21 0C16.8466 0 12.7865 0.967708 9.33304 2.78075C5.8796 4.59379 3.18798 7.17074 1.59854 10.1857C0.0090989 13.2007 -0.406771 16.5183 0.403519 19.719C1.21381 22.9197 3.21386 25.8597 6.15077 28.1673C9.08767 30.4748 12.8295 32.0463 16.9031 32.683C20.9767 33.3196 25.1991 32.9929 29.0364 31.744C32.8736 30.4952 36.1534 28.3803 38.4609 25.6669C40.7684 22.9535 42 19.7634 42 16.5C42.008 14.3395 41.4744 12.1989 40.4295 10.2004C39.3846 8.20194 37.849 6.38474 35.9103 4.85258C33.9716 3.32041 31.6678 2.10327 29.1304 1.27067C26.593 0.43806 23.8718 0.00628665 21.122 0H21ZM21.3559 17.0593L19.1695 22.8523H30.8644C30.9419 22.8502 31.0191 22.86 31.0917 22.8814C31.1643 22.9027 31.2309 22.9351 31.2875 22.9767C31.3442 23.0182 31.3899 23.0681 31.422 23.1236C31.4541 23.179 31.472 23.2389 31.4746 23.2998V23.4516L30.4576 26.2082C30.4128 26.3386 30.3129 26.4531 30.1743 26.533C30.0357 26.6128 29.8666 26.6533 29.6949 26.6477H11.7966L14.7966 18.6174L11.4407 19.4165L12.2034 17.5787L15.5593 16.7797L19.7797 5.51332C19.8261 5.38368 19.9265 5.26999 20.0647 5.19035C20.2029 5.11071 20.3711 5.0697 20.5424 5.07385H25.0678C25.1453 5.07171 25.2225 5.0816 25.2951 5.10294C25.3677 5.12427 25.4343 5.15665 25.4909 5.1982C25.5476 5.23976 25.5933 5.28969 25.6254 5.34513C25.6575 5.40057 25.6754 5.46044 25.678 5.52131V5.67312L22.1187 15.1816L25.4746 14.3826L24.7627 16.3002L21.3559 17.0593Z",
    fill: "#100F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoin);
export default __webpack_public_path__ + "static/media/litecoin.8c1f9f29635b0a01d266f16a6e3602c3.svg";
export { ForwardRef as ReactComponent };